export class RapportiniToSend {
    emailToSend: string;
    missionId: number;
    base64: string;
}